module.exports = __webpack_public_path__ + "assets/icon-comments.26b34229.svg";